"use client";

import { Close } from "@mui/icons-material";
import React, { useRef } from "react";

import { Text, TextVariant, TextWeight } from "../../components";

type SizeTableDrawerProps = {
  sizeTableContent: string;
  topText: string | boolean;
  bottomText: string | boolean;
  setOpenSizeTableDrawer: (open: boolean) => void;
  productReference: string;
};

const SizeTableDrawer: React.FC<SizeTableDrawerProps> = ({
  sizeTableContent,
  topText,
  bottomText,
  setOpenSizeTableDrawer,
  productReference,
}) => {
  const interactionRef = useRef<HTMLDivElement>(null);

  const formattedProductReference =
    productReference && productReference.slice(0, 5);

  return (
    <div className="w-screen md:w-auto md:min-w-[600px] relative px-8 pt-[70px] h-full overflow-hidden">
      <div className="h-auto" ref={interactionRef}>
        {/* Header */}
        <div className="flex gap-2 w-full justify-between">
          <Text
            text={`Tabela rozmiarów dla produktu ${formattedProductReference}`}
            variant={TextVariant.H6}
            weight={TextWeight.BOLD}
            className="mb-4"
          />
          <div
            onClick={() => setOpenSizeTableDrawer(false)}
            className="cursor-pointer"
          >
            <Close className="w-5 h-5" />
          </div>
        </div>
      </div>

      <div
        className="flex flex-col h-full py-5"
        style={{
          height: interactionRef.current?.offsetHeight
            ? `calc(100% - ${interactionRef.current.offsetHeight}px)`
            : "100%",
          maxHeight: interactionRef.current?.offsetHeight
            ? `calc(100% - ${interactionRef.current.offsetHeight}px)`
            : "100%",
        }}
      >
        <div className="flex flex-col gap-4">
          {topText && typeof topText === "string" && (
            <Text
              text={topText}
              variant={TextVariant.H6}
              weight={TextWeight.BOLD}
            />
          )}

          <div
            className="w-full overflow-y-auto max-h-[calc(100vh-200px)]"
            dangerouslySetInnerHTML={{ __html: sizeTableContent }}
          />

          {bottomText && typeof bottomText === "string" && (
            <Text
              text={bottomText}
              variant={TextVariant.H6}
              weight={TextWeight.BOLD}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SizeTableDrawer;
